import * as React from "react";
import {config} from "../../../config/domain";
import {isLoggedIn} from "../../../components/service/login/loginService"
import "../../../assets/scss/components/header/nav/navDesk.scss";
import "../../../assets/scss/components/header/nav/navMob.scss";
import {tocList, reportsList} from "../client/clientNavList";
import {Idevice} from "../../types/device";

export interface IMenuListProps {
    loggedIn?: boolean;
    deviceState?: Idevice;
}

export function MenuList(props: IMenuListProps) {
    const smallCaseUrl = isLoggedIn()
        ? config.rootUrl + "/vlogin/smallcase?params=26utm_source%3Dedelweiss%26utm_medium%3Dwebsite%26utm_campaign%3Dhomepage%26utm_content%3Dguided-investing"
        : "https://smallcases.edelweiss.in?params=26utm_source%3Dedelweiss%26utm_medium%3Dwebsite%26utm_campaign%3Dhomepage%26utm_content%3Dguided-investing";
    const menuList = [
        {
            text: "<small>Invest</small>",
            id: "investBlock",
            active: React.useRef(null),
            subMenuList: [
                {
                    link: false,
                    text: "Investment",
                    id: "investmentsubBlock",
                    subList: [
                        {
                            link: config.rootUrl + "oyo/equity",
                            text: "Stocks", 
                        } ,
                        {
                            link: config.rootUrl + "/oyo/mutualfund",
                            text: "Mutual Funds", 
                        },
                        {
                            link: config.rootUrl + "market/futures-and-options-trends",
                            text: "Derivatives", 
                        } ,
                        {
                            link: config.rootUrl + "market/stock-market-index/#commodities",
                            text: "Commodities", 
                        },
                        {
                            link: config.rootUrl + "market/stock-market-index/#currency",
                            text: "Currency", 
                        } ,
                        {
                            link: config.rootUrl + "/oyo/mutualfund",
                            text: "small case", 
                            
                        },
                     ]
                },
                {
                    link: false,
                    text: "Primary Markets",
                    class: "investmentsubBlock",
                    subList: [
                        {
                            link: config.rootUrl + "new-issues/#ipo",
                            text: "IPO", 
                        } ,
                        {
                            link: config.rootUrl + "new-issues/#ncd",
                            text: "NCD", 
                        },
                        {
                            link: config.rootUrl + "new-issues/#ofs",
                            text: "OFS", 
                        } ,
                        {
                            link: config.rootUrl + "new-issues/#nfo",
                            text: "New Fund Offer", 
                        },
                       
                     ]
                },    
                 {
                    link: false,
                    text: "Products",
                    class: "investmentsubBlock",
                    subList: [
                        {
                            link: config.rootUrl + "generic-insurance",
                            text: "Insurance", 
                        } ,
                       
                       
                     ]
                },
                {
                    link: false,
                    text: "Platforms",
                    class: "investmentsubBlock",
                    
                  
                    subList: [
                        { 
                          
                            link: config.rootUrl + "nuvama-markets-share-market-live-trading-app",
                            text:  "Nuvama Markets"
                        } ,
                        {
                            
                            link: config.rootUrl + "tx3",
                            text: "TX3", 
                        } ,
                        {
                            link: config.rootUrl + "api-connect",
                            text: "API Connect", 
                            
                        } ,
                       
                       
                     ]
                }
            ]
        },
        {
            text: "<small>Resources</small>",
            id: "resourceBlock",
            active: React.useRef(null),
            subMenuList: [
                {
                    text: "Research",
                    id: "mi21",
                    subList: [
                        {
                            link: config.rootUrl + "research",
                            text: "Reports", 
                        } ,
                        {
                            link: config.rootUrl + "oyo/equity/top-market-and-stock-recommendations/equity",
                            text: "Recommendations", 
                        } ,
                    ]
                },
                {
                    text: "Gain Knowledge",
                    id: "mi22",
                    subList: [
                        {
                            link: config.rootUrl + "insight",
                            text: "Insights", 
                        } ,
                        {
                            link: config.rootUrl + "Investology",
                            text: "Investology", 
                        } ,
                    ]
                },
            ]
        },
        {
            text: "<small>Markets</small>",
            id: "marketBlock",
            active: React.useRef(null),
            subMenuList: [
                {
                    link: config.rootUrl + "market",
                    text: "Market Today",
                    id: "mi31"

                },
                {
                    link: config.rootUrl + "market/deep-dive-into-stock-markets",
                    text: "Markets Movements",
                    id: "mi32"
                },
                {
                    link: config.rootUrl + "market/stock-market-index",
                    text: "Market Indices",
                    id: "mi33"
                },
                {
                    link: config.rootUrl + "market/deep-dive-into-stock-markets/share-market-map",
                    text: "Market Map",
                    id: "mi34"
                },
                {
                    link: config.rootUrl + "market/futures-and-options-trends",
                    text: "F&O Trends",
                    id: "mi35"
                },
                {
                    link: config.rootUrl + "market/nse-option-chain",
                    text: "Option Chain",
                    id: "mi36"
                },
                {
                    link: config.rootUrl + "market/fii-dii-activity",
                    text: "FII & DII Activity",
                    id: "mi37"
                },
                {
                    link: config.rootUrl + "market/corporate-actions-and-economic-events",
                    text: "Economic & Company Events",
                    id: "mi38"
                }
            ]
        },
        {
            text: "<small>Pricing</small>",
            id: "pricingBlock",
            active: React.useRef(null),
            subMenuList: [
                {
                    link: config.rootUrl + "research",
                    text: "Brokerage Rates",
                    id: "mi41"
                },
                // {
                //     link: config.rootUrl + "oyo/equity/top-market-and-stock-recommendations/equity?redirectParam=EQ%2CLong%20term",
                //     text: "Infinity Plan",
                //     id: "mi42"
                // }
            ]
        },
        {
            text: "<small>Support</small>",
            id: "supportBlock",
            cn: "listTwo",
            active: React.useRef(null),
            subMenuList: [
                {
                    link: config.rootUrl + "insight",
                    text: "Check Account Opening Status",
                    id: "mi51"
                },
                {
                    link: config.rootUrl + "insight",
                    text: "Visit FAQs",
                    id: "mi51"
                },
                {
                    link: config.rootUrl + "insight",
                    text: "1800-102-3335 (8.30 AM - 5.30 PM)",
                    id: "mi51"
                },
                {
                    link: config.rootUrl + "insight",
                    text: "helpdesk@nuvama.com",
                    id: "mi51"
                },
                {
                    link: config.rootUrl + "investology",
                    text: "Locate Us",
                    id: "mi52"
                }
            ]
        },
    ];
    const sessListEmbed = {
        toc: [
            {
                text: "Buy/Sell",
                id: "miL1",
                active: React.useRef(null),
                subMenuList: tocList
            }
        ],
        reports: [
            {
                text: "My Reports",
                id: "miL2",
                active: React.useRef(null),
                subMenuList: reportsList
            }
        ]
    };
    const UserMobMenu = {
        toc: sessListEmbed.toc.map((item: any, index: number) => (
            <li className={"mainMenuItem " + (item.subMenuList.length ? " hasSubMenu" : "")} ref={item.active}
                id={item.id} key={index}>
                <label
                    onClick={() => menuAccord(item)}
                    className=" mainMenuLabel"
                    dangerouslySetInnerHTML={{
                        __html: item.text
                    }}
                ></label>
                {item.subMenuList && item.subMenuList.length !== 0 && (
                    <div className={"subMenuWrapper "}>
                        <ul className="SubMenuList">
                            {item.subMenuList.map((sItem: any, index: number) =>
                                sItem.link ? (
                                    <li key={index} className="subMenuItem">
                                        
                                        <a
                                            className="ed_link subMenuLink"
                                            href={sItem.link}
                                            dangerouslySetInnerHTML={{
                                                __html: sItem.text
                                            }}
                                        ></a>
                                    </li>
                                ) : (
                                    sItem.subList.map((sItem: any, index: number) => (
                                        <li key={index} className="subMenuItem">
                                            <a
                                                className="ed_link subMenuLink"
                                                href={sItem.link}
                                                dangerouslySetInnerHTML={{
                                                    __html: sItem.text
                                                }}
                                            ></a>
                                        </li>
                                    ))
                                )
                            )}
                        </ul>
                    </div>
                )}
            </li>
        )),
        reports: sessListEmbed.reports.map((item: any, index: number) => (
            <li className={"mainMenuItem " + (item.subMenuList.length ? " hasSubMenu" : "")} ref={item.active}
                id={item.id} key={index}>
                <label
                    onClick={() => menuAccord(item)}
                    className= " mainMenuLabel"
                    dangerouslySetInnerHTML={{
                        __html: item.text
                    }}
                ></label>
                {item.subMenuList && item.subMenuList.length !== 0 && (
                    <div className={"subMenuWrapper "}>
                        <ul className="SubMenuList">
                            {item.subMenuList.map((sItem: any, index: number) =>
                                sItem.link ? (
                                    <li key={index} className="subMenuItem">
                                        <a
                                            className="ed_link subMenuLink"
                                            href={sItem.link}
                                            dangerouslySetInnerHTML={{
                                                __html: sItem.text
                                            }}
                                        ></a>
                                    </li>
                                ) : (
                                    sItem.subList.map((sItem: any, index: number) => (
                                        <li key={index} className="subMenuItem">
                                            <a
                                                className="ed_link subMenuLink"
                                                href={sItem.link}
                                                dangerouslySetInnerHTML={{
                                                    __html: sItem.text
                                                }}
                                            ></a>
                                        </li>
                                    ))
                                )
                            )}
                        </ul>
                    </div>
                )}
            </li>
        ))
    };

    //expand and collapse the menu items on click of group head element
    function menuAccord(item: any) {
        let expEle = document.getElementById("navList"),
            navExpBlk = expEle ? expEle?.getElementsByClassName("expand") : [],
            itemCur = item.active.current;
        // console.log(navExpBlk);
        for (let i = 0; i < navExpBlk.length; i++) {
            const ele = navExpBlk[i];
            ele.id !== item.active.current.id && ele.classList.remove("expand");
        }

        if (itemCur.className.indexOf("expand") < 0) {
            itemCur.classList.add("expand");
        } else {
            itemCur.classList.remove("expand");
        }
    }

    //

    return (
        <>
            <nav className="navList" id="navList">
                <ul className="mainMenuItems">
                    {/* for mobile */}
                    {/* show only for client  */}
                    {props.loggedIn && props.deviceState?.isMobile && UserMobMenu.toc}
                    {props.loggedIn && props.deviceState?.isMobile && UserMobMenu.reports}
                    {menuList.map((item: any, index: number) => (
                        <li
                            className={
                                "mainMenuItem "  + (item.subMenuList.length ? " hasSubMenu" : "") + (item.hideDesk ? " deskNone" : "")
                            }
                            ref={item.active}
                            id={item.id}
                            key={index}
                        >
                            {/* //for dekstop since there is navigation on mobile there is no navigation on clicking the main menu  */}
                            {props.deviceState?.isDesktop && (
                                <label
                                    className=" ed_link mainMenuLink"
                                    dangerouslySetInnerHTML={{
                                        __html: item.text
                                    }}
                                ></label>
                            )}
                            {/* mobile handle as link if there is no submenu list or else as label */}
                            {item.subMenuList.length !== 0 && props.deviceState?.isMobile && (
                                <label
                                    onClick={() => menuAccord(item)}
                                    className= " mainMenuLabel"
                                    dangerouslySetInnerHTML={{
                                        __html: item.text
                                    }}
                                ></label>
                            )}
                            {item.subMenuList.length === 0 && props.deviceState?.isMobile && ((isLoggedIn() && !item.hideLogin) || !isLoggedIn()) && (
                                <a
                                    className= " ed_link mainMenuLabel"
                                    href={item.link}
                                    dangerouslySetInnerHTML={{
                                        __html: item.text
                                    }}
                                ></a>
                            )}
                {item.subMenuList && item.subMenuList.length !== 0 && (
                    <div className={"subMenuWrapper "}>
                        <ul className="SubMenuList">
                           <div className="menulist-width">
                            {item.subMenuList.map((sItem: any, index: number) =>
                              
                                    <li key={index} className="subMenuItem">
                                        
                                        <a
                                            className="ed_link submenuLinkMedium headingreduce"
                                            href={sItem.link}
                                            dangerouslySetInnerHTML={{
                                                __html: sItem.text
                                            }}
                                        ></a>
                                        {sItem.subList && sItem.subList.length !== 0 && sItem.subList.map((slItem: any, index: number) => (
                                           
                                                <li key={index} className="sublist-link">
                                                        <a 
                                                        href={slItem.link}
                                                        dangerouslySetInnerHTML={{
                                                            __html: slItem.text
                                                        }}></a>
                                                </li>
                                             

                                            ))}
                                    </li>
                                  
                              
                            )}
                              </div>
                        </ul>
                    </div>
                )}
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    );
}

export default MenuList;
